import { useState } from 'react';

import { Box, Card, Text } from '@zillow/constellation-10';
import { LoadingHeading } from '@zg-rentals/loading-components';

import { connectedCardRecipe, headingWrapperRecipe } from './styles';

type Props = {
  children?: React.ReactNode;
  css?: object;
  ctaComponent?: React.ReactNode;
  ctaFontColor?: string;
  ctaFontType?: string | object;
  enableHover?: boolean;
  hideBorderOnMobile?: boolean;
  includeBorderTop?: boolean;
  isLoading?: boolean;
  justifyHeadingContent?: 'flex-start' | 'center' | 'space-between';
  leftComponent?: React.ReactNode;
  title?: string;
  titleGrow?: number;
};

const ConnectedModuleCard = ({
  children,
  css: cssProp,
  ctaComponent,
  ctaFontColor = 'text.neutral',
  ctaFontType = { base: 'body-sm', lg: 'body' },
  enableHover: pEnableHover = false,
  hideBorderOnMobile = false,
  includeBorderTop = false,
  isLoading = false,
  justifyHeadingContent = 'flex-start',
  leftComponent,
  title,
  titleGrow = 1,
}: Props) => {
  const [enableHover, setEnableHover] = useState(false);

  const handleMouseOver = () => {
    if (pEnableHover) setEnableHover(true);
  };

  const handleMouseOut = () => {
    if (pEnableHover) setEnableHover(false);
  };

  return (
    <Card.Root
      data-testid="ConnectedCard"
      className="ConnectedCard"
      tone="neutral"
      outlined
      elevated={false}
      css={{ ...connectedCardRecipe.raw({ includeBorderTop, enableHover, hideBorderOnMobile }), ...cssProp }}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {(leftComponent || title || ctaComponent) && (
        <Box className="ConnectedCard-TitleWrapper" css={headingWrapperRecipe.raw({ justifyHeadingContent })}>
          {leftComponent && <div data-testid="ConnectedCard-Heading">{leftComponent}</div>}

          {title && (
            <LoadingHeading
              data-testid="ConnectedCard-Heading"
              level={2}
              isLoading={isLoading}
              loadingWidth="40%"
              css={{
                fontSize: { base: 'body', lg: 'heading-xs' },
                lineHeight: { base: 'body', lg: 'heading-xs' },
                flexGrow: titleGrow,
                marginRight: '400',
                color: enableHover ? 'text.action.hero.default' : 'text.neutral',
              }}
            >
              {title}
            </LoadingHeading>
          )}

          <Box css={{ marginBottom: { base: '400', lg: '0' } }} />

          {ctaComponent && (
            <Text
              className="ConnectedCard-CTA"
              css={{
                textStyle: ctaFontType,
                color: enableHover ? 'text.action.hero.default' : ctaFontColor,
                _hover: { color: 'text.action.hero.default' },
              }}
            >
              {ctaComponent}
            </Text>
          )}
        </Box>
      )}
      {children}
    </Card.Root>
  );
};

export default ConnectedModuleCard;
